<template>
  <div>
    <v-layout style="background-color: white" justify-end>
      <div></div>
      <!-- <h1>RED RDDD</h1> -->
      <v-select
        :items="items"
        :label="$t('dispatching.bookingLog.actionType')"
        v-model="status"
        @change="typeFilter"
        style="max-width: 250px"
      ></v-select>
    </v-layout>

    <DataTable
      :url="api.ACTIONS.BOOKING_LOG($route.params.id)"
      :appends="['status']"
      :initial-url-search-params="requestType"
      :fields-hidden-main="[
        'deleted_at',
        'updated_at',
        'entity',
        'entity_type',
        'id',
        'entity_id',
        'requester_captain_id',
        'receiver_captain_id',
        'requester_booking_id',
        'requester_captain',
        'receiver_captain',
        'receiver_booking_id',
        'expired_time',
        'booking_id',
        'captain_id',
      ]"
      :disableSearch="true"
      :enableEdit="false"
      :enableAdd="false"
      :enableDelete="false"
      :titles="titles"
      :formatter="formatters"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "BookingLog",
  title() {
    return this.$t("dispatching.bookingLog.title");
  },
  components: {
    LoadingComponent,
    DataTable,
  },

  data() {
    return {
      loading: false,
      requestType: "",
      status: "",
      items: [
        "all",
        "transfer_request",
        "exchange_request",
        "redistribution_log",
        "captain_suggestion",
        "reschedule_log",
        "create_booking",
        "cancellation_log",
        "manual_dispatch"
      ],
      formatters: {
        created_at(value) {
          return moment(value).format("DD-MM-YYYY - HH:mm:ss");
        },
      },
    };
  },
  mounted() {
    console.log("mounted");
  },
  methods: {
    typeFilter() {
      console.log("changed");
      this.requestType = new URLSearchParams(`type=${this.status}`);
    },
  },

  computed: {
    titles() {
      return {
        created_at: this.$t("dispatching.bookingLog.creationDate"),
        type: this.$t("dispatching.bookingLog.type"),
        doer: this.$t("dispatching.bookingLog.doer"),
        captain_status: this.$t("dispatching.bookingLog.captainStatus"),
        recipient: this.$t("dispatching.bookingLog.recipient"),
        taxi_number: this.$t("dispatching.bookingLog.taxiNumber"),
        status: this.$t("common.status"),
        old_time: this.$t("dispatching.bookingLog.oldTime"),
        new_time: this.$t("dispatching.bookingLog.newTime"),
      };
    },
    params() {
      const params = new URLSearchParams();
      // params.append("id", this.captain.id);
      params.append("type", "all");
      return params;
    },
  },
};
</script>

<style scoped></style>
